const inputsAuditSecurity = {
  fio: {
    key: "fio",
    label: "Пользователь",
    type: "text",
    disabled: false,
    required: false,
  },
  auditSecurityEventId: {
    key: "auditSecurityEventId",
    label: "Событие",
    type: "selectWithSearch",
    disabled: false,
    required: false,
    options: [{ value: 0, label: "Все", key: "auditSecurityEventId" }],
  },
  startDate: {
    key: "startDate",
    label: "Дата события с",
    type: "date",
    disabled: false,
    required: false,
  },
  endDate: {
    key: "endDate",
    label: "Дата события по",
    type: "date",
    disabled: false,
    required: false,
  },
};
export const serInputsAuditSecurity = (type, props) => {
  switch (type) {
    case "firstInit": {
      if ((inputsAuditSecurity.auditSecurityEventId.options.length = 1)) {
        inputsAuditSecurity.auditSecurityEventId.options.push(...props);
      }
    }
  }
};
export const getInputsAuditSecurity = () => inputsAuditSecurity;
